import React from 'react';
import styled from 'styled-components';
import RelativeDay from '../../components/Day/RelativeDay';
import ShowMore from './ShowMore';
import SlotSelectorStates from '../../components/SlotSelectorStates';

const Container = styled.div.withConfig({ componentId: 'sc-8b1slt-0' })`
  padding: 0px 10px;
`;

const DayShowMoreContainer = styled.div.withConfig({ componentId: 'sc-8b1slt-1' })`
  width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto 15px;
`;

type OwnProps = {
  selectedDate: any;
  location: any;
  modalState?: any;
  futureSlotData: any;
  handleSelectSlot: (...args: any[]) => any;
  nextDate: any;
  selectedSlots: any[];
  setHasOpenedTimeSelectorModal?: (...args: any[]) => any;
  shouldShowWalkInCopy?: boolean;
  isVisible?: boolean;
  handleClickShowMore?: (...args: any[]) => any;
  setAndHandleDate: (...args: any[]) => any;
  // Below props are for old booking flow
  shouldSelectFirstSlotAsInitialValue: boolean;
  shouldSetSelectedSlotToFirstVisibleSlot: boolean;
  shouldShowNextAvailableAppointmentCta: boolean;
};

// @ts-expect-error ts-migrate(2456) FIXME: Type alias 'Props' circularly references itself.
type Props = OwnProps & typeof SlotsTodayOrTomorrow.defaultProps;

// @ts-expect-error ts-migrate(7022) FIXME: 'SlotsTodayOrTomorrow' implicitly has type 'any' b... Remove this comment to see the full error message
const SlotsTodayOrTomorrow = (props: Props) => {
  const {
    location,
    futureSlotData,
    handleSelectSlot,
    nextDate,
    selectedSlots,
    shouldShowWalkInCopy,
    selectedDate,
    isVisible,
    handleClickShowMore,
    setAndHandleDate,
    // Below props are for old booking flow
    shouldSelectFirstSlotAsInitialValue,
    shouldSetSelectedSlotToFirstVisibleSlot,
    shouldShowNextAvailableAppointmentCta,
  } = props;

  if (!isVisible) return null;

  return (
    <Container>
      <DayShowMoreContainer>
        <RelativeDay selectedDate={selectedDate} timeZone={location.timeZone} />

        <ShowMore onClick={handleClickShowMore} shouldShowMore />
      </DayShowMoreContainer>

      <SlotSelectorStates
        allowExpandInPlace={false}
        futureSlotData={futureSlotData}
        handleClickShowMore={handleClickShowMore}
        handleSelectSlot={handleSelectSlot}
        location={location}
        nextDate={nextDate}
        selectedDate={selectedDate}
        selectedSlots={selectedSlots}
        setAndHandleDate={setAndHandleDate}
        shouldSelectFirstSlotAsInitialValue={shouldSelectFirstSlotAsInitialValue}
        shouldSetSelectedSlotToFirstVisibleSlot={shouldSetSelectedSlotToFirstVisibleSlot}
        shouldShowNextAvailableAppointmentCta={shouldShowNextAvailableAppointmentCta}
        shouldShowWalkInCopy={shouldShowWalkInCopy}
      />
    </Container>
  );
};

export default SlotsTodayOrTomorrow;
